export const CREATE_PARTNER_COMPANY = `
  mutation createPartnerCompany($partnerCompanyRequest: JSON!) {
    createPartnerCompany(partnerCompanyRequest: $partnerCompanyRequest) {
      message
      partnerCompany { id name slug description email phone status subscription_id }
    }
  }
`;

export const UPDATE_PARTNER_COMPANY = `
  mutation updatePartnerCompany($id: ID!, $partnerCompanyRequest: JSON!) {
    updatePartnerCompany(id: $id, partnerCompanyRequest: $partnerCompanyRequest) {
      message
      partnerCompany { id name slug description email phone status subscription_id }
    }
  }
`;

export const DELETE_PARTNER_COMPANY = `
  mutation deletePartnerCompany($id: ID!) {
    deletePartnerCompany(id: $id) {
      message
    }
  }
`;

export const CREATE_PARTNER = `
  mutation createPartner($partnerRequest: JSON!, $frontIdCard: Upload, $backIdCard: Upload, $photo: Upload) {
    createPartner(partnerRequest: $partnerRequest, frontIdCard: $frontIdCard, backIdCard: $backIdCard, photo: $photo) {
      message
      upcomingmessage
      technician { id firstName lastName email }
      user { id email ci codigo }
      partnerCompany { id name }
    }
  }
`;
